/**
 * OrbDocCoreConceptsPagesSLOrbDocCoreConceptsPagesSLPage
 *
 * Page component for OrbDocCoreConceptsPagesSLOrbDocCoreConceptsPagesSLPage
 * Path: /sl/docs/core-concepts/pages
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsPagesSLDocScreenView as __OrbDocCoreConceptsPagesSLDocScreenView } from '@/components/traits/OrbDocCoreConceptsPagesSLDocScreenView';
import { OrbDocCoreConceptsPagesSLDocAnalyticsView as __OrbDocCoreConceptsPagesSLDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsPagesSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsPagesSLOrbDocCoreConceptsPagesSLPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsPagesSLOrbDocCoreConceptsPagesSLPage(_props: OrbDocCoreConceptsPagesSLOrbDocCoreConceptsPagesSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Strani","description":"Poti in kako si lastnosti na isti poti delijo zaslon.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/pages"},{"locale":"ar","path":"/ar/docs/core-concepts/pages"},{"locale":"sl","path":"/sl/docs/core-concepts/pages"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsPagesSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsPagesSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsPagesSLOrbDocCoreConceptsPagesSLPage;
